var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2026 6.96051C20.7421 7.52136 20.9181 8.79496 20.9181 8.79496C20.9181 8.79496 21.0981 10.2909 21.0981 11.7863V13.1887C21.0981 14.6847 20.9181 16.1801 20.9181 16.1801C20.9181 16.1801 20.7421 17.4537 20.2026 18.0146C19.5859 18.6781 18.9021 18.7466 18.5155 18.7853C18.473 18.7896 18.4341 18.7935 18.3993 18.7978C15.8804 18.9849 12.0981 18.9907 12.0981 18.9907C12.0981 18.9907 7.41814 18.9468 5.97814 18.8047C5.90992 18.7916 5.82721 18.7815 5.73355 18.7699C5.27742 18.7137 4.56149 18.6256 3.99308 18.0146C3.45364 17.4537 3.27814 16.1801 3.27814 16.1801C3.27814 16.1801 3.09814 14.6847 3.09814 13.1887V11.7863C3.09814 10.2909 3.27814 8.79496 3.27814 8.79496C3.27814 8.79496 3.45364 7.52136 3.99308 6.96051C4.61119 6.29611 5.29569 6.2283 5.68226 6.19C5.72417 6.18585 5.76258 6.18205 5.79702 6.17786C8.31589 5.99072 12.0942 5.99072 12.0942 5.99072H12.1021C12.1021 5.99072 15.8804 5.99072 18.3993 6.17786C18.4337 6.18205 18.4721 6.18586 18.5141 6.19002C18.9004 6.22832 19.5851 6.29621 20.2026 6.96051ZM10.2391 9.69486L10.2396 14.888L15.1025 12.3004L10.2391 9.69486Z",
    fill: "#090B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.a945d2b137834ce66c9f397dfe275f9c.svg";
export { ForwardRef as ReactComponent };